import { Box, CircularProgress } from "@mui/material";

const Loader = () => (
    <Box
        sx={{
            height: "60vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        }}
    >
        <CircularProgress />
    </Box>
);

export default Loader;
